import axios from 'axios';
import config from 'config';
import { setupRequestInterceptors } from './interceptors';

const instance = axios.create({ baseURL: `${config.API_BASE_URL}/files` });
const request = setupRequestInterceptors(instance);

const api = {
  getDocuments: async (params) => {
    const { data } = await request.get(`/documents`, { params });
    return data.map((doc) => ({ ...doc, documentType: doc.type }));
  },
};
export { request };
export default api;
